import { render, staticRenderFns } from "./Phase4Container.vue?vue&type=template&id=b262d4a6&scoped=true&"
import script from "./Phase4Container.vue?vue&type=script&lang=js&"
export * from "./Phase4Container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b262d4a6",
  null
  
)

export default component.exports